import { useLoaderData } from "react-router";
import DocumentForm from "./DocumentForm";

export default function EditOrgDocument() {
  const document = useLoaderData();
  return <DocumentForm document={document} returnPath="/orgDocuments" />;
}
